import cn from 'clsx'
import React, {
  FC,
  isValidElement,
  ReactNode,
  useEffect,
  useRef,
  useState,
} from 'react'
import styles from './LineClampCollapse.module.scss'
import useMeasure from 'react-use-measure'
import ArrowRightIcon from '@components/icons/ArrowRightIcon/ArrowRightIcon'
import gsap from 'gsap'
import clsx from 'clsx'
export interface CollapseProps {
  title: String
  children: ReactNode
}

const LineClampCollapse: FC<CollapseProps> = ({ children, title }) => {
  const [isActive, setActive] = useState(false)
  const [ref, { height: viewHeight }] = useMeasure()
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!containerRef.current) return
    gsap.to(containerRef.current, {
      height: isActive ? viewHeight : 0,
      opacity: isActive ? 1 : 0,
      // marginBottom: isActive ? 16 : 0,
      duration: 0.2,
    })
  }, [containerRef.current, isActive])

  const toggle = () => setActive((x) => !x)

  return (
    <div
      className={clsx(styles.root, { 'py-6': isActive })}
      aria-expanded={isActive}
    >
      <div
        role="button"
        tabIndex={0}
        onClick={toggle}
        className={styles.header}
      >
        <span className={clsx(styles.label, 'kingcaslon')}>{title}</span>

        <ArrowRightIcon
          className={cn(styles.icon, { [styles.open]: isActive })}
          color="black"
          strokeWidth={3}
        />
      </div>
      <div ref={containerRef} className={'overflow-hidden'}>
        <div ref={ref} className={styles.content}>
          {children}
        </div>
      </div>
    </div>
  )
}

export default React.memo(LineClampCollapse)
